import { styled } from "@mui/styles";

export const PageWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  height: "100%",
  padding: "0px 16px",
  paddingBottom: "32px",
  justifyContent: "center",
  alignItems: "center",
  gap: "12px",
  flexShrink: 0,
}));

interface AnalyticsTitleProps {
  color?: string;
}
export const AnalyticsTitleWrapper = styled("div")(() => ({
  display: "flex",
  width: "100%",
  padding: "18px 12px 8px 8px",
  flexDirection: "row",
  justifyContent: "space-between",
  gap: "8px",
}));

export const AnalyticsTitle = styled("span")<AnalyticsTitleProps>(({ color }) => ({
  color: color ?? "#FC4C4C",
  fontFamily: "Roobert",
  fontSize: "28px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "34px",
  letterSpacing: "-0.56px",
}));

export const AnalyticsText = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  fontSize: "14px",
}));

export const AnalyticsSubtitle = styled("span")({
  color: "#FC4C4C",
});

// Create a style component for the grid styles
export const GridContainer = styled("div")({
  width: "100%",

  "& .react-grid-placeholder": {
    background: "#D1D5DB !important",
    opacity: "0.2 !important",
    borderRadius: "8px",
    border: "2px solid #D1D5DB !important",
    transition:
      "background-color 200ms cubic-bezier(0.4, 0, 0.2, 1), opacity 200ms cubic-bezier(0.4, 0, 0.2, 1)",
  },
});

// Create styled components for each analytics section
export const GridSection = styled("div")(() => ({
  borderRadius: "8px",
  position: "relative",
  gap: "16px",
  boxShadow: "0 2px 4px 0 rgba(229, 225, 215, 0.5)",
  border: "1px solid rgba(229, 225, 215, 0.6)",
  // Hover effect
  transition: "all 0.2s ease-in-out",
  "&:hover": {
    zIndex: 1,
    transform: "translateY(-2px)",
    boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.1)",
  },

  "&:hover, &.menu-open": {
    // Add menu-open class
    border: `1px solid #D1D5DB`,
    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
    "& .remove-button": {
      opacity: 1,
    },
  },
}));

export const LoadingGridSection = styled(GridSection)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const ChartHeader = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "12px",
  borderBottom: "1px solid rgba(0, 0, 0, 0.06)",
  fontFamily: "Söhne",
});

export const DraggableWrapper = styled("div")({
  cursor: "grab",
  width: "100%",
  flex: 1,
  ".drag-handle": {
    display: "flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "green",
    },
  },
});

export const HeadingText = styled("div")(({ theme }) => ({
  fontSize: "12px",
  color: "inherit",
  fontWeight: 600,
  display: "flex",
  gap: "8px",
  alignItems: "center",
  width: "fit-content",
}));

export const MenuWrapper = styled("div")(() => ({
  width: "fit-content",
  display: "flex",
  justifyContent: "flex-end",
}));

export const MainHeaderWrapper = styled("div")(() => ({
  width: "fit-content",
  display: "flex",
  float: "right",
  position: "relative",
}));

export const MainMenuWrapper = styled("div")(() => ({
  display: "flex",
  justifyContent: "flex-end",
  position: "absolute",
  right: 0,
  width: "140px",
}));

export const ChartSelector = styled("div")({
  position: "absolute",
  top: "130px",
  right: "24px",
  backgroundColor: "white",
  borderRadius: "8px",
  boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
  padding: "8px 0",
  zIndex: 10,
});

export const ChartSelectorItem = styled("div")({
  padding: "8px 16px",
  cursor: "pointer",
  width: "200px",
  fontSize: "12px",
  // Optional: add hover effect on the button itself
  "&:hover": {
    backgroundColor: "#F3F4F6",
  },
});

export const FilterWrapper = styled("div")({
  display: "flex",
  alignItems: "flex-start",
  gap: "12px",
});
